import React from 'react'
import { BannerSwBTC } from './BannerSwBTC'
import { BannerEarnETH } from './BannerEarnETH'

export function AppBanner() {
  return <BannerEarnETH />
}
